<template>
    <div class="main-layout coffee">
        <div class="order-header">
            <a class="btn-back" @click="backHistory()">
                <img
                    class="white-back"
                    src="@/assets/campaignlist/white_back.svg"
                    alt=""
                />
            </a>
            <div class="header-title">{{ dateTime }}</div>
        </div>
        <LocationDropdown :part="pathGoBack" />
        <div class="wrapper__location">
            <div class="location-text">
                <div class="location-header">
                    <img
                        class="top-button"
                        src="@/assets/campaignlist/icon_clock.svg"
                    />
                    <span>Pick up Time</span>
                </div>
                <div class="location-content">
                    <span v-if="setTime">{{ setTime }}</span>
                </div>
            </div>
            <div class="location-arrow">
                <img
                    class="top-button"
                    src="@/assets/home/white_dropdown.svg"
                />
            </div>
        </div>
        <div class="main-changeplan">
            <ul v-if="isLoaded" class="menu-container">
                <ChangePlanItem
                    v-for="(campaign, k) in campaigns"
                    :key="k"
                    :index="k"
                    :campaign="campaign"
                    @onChoose="chooseCampaign($event)"
                    :isActive="k === activeCampaign ? true : false"
                />
            </ul>
        </div>
        <div class="footer-main">
            <div class="footer-header"></div>
            <div class="footer-body">
                <div class="brown-btn">บันทึก</div>
                <div
                    class="underline-btn"
                    @click="$bvModal.show('modalCancle')"
                >
                    Cancel Today's Coffee
                </div>
            </div>
        </div>
        <b-modal
            id="modalCancle"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="order-main">
                <div class="order-header">
                    <div class="title-scc">
                        <h2>
                            Cancle today's coffee
                        </h2>
                        <div class="order-desc">
                            คุณต้องการยกเลิกรายการวันนี้หรือไม่ ?
                        </div>
                    </div>
                </div>
                <div class="brown-btn">ยืนยัน</div>
                <div
                    class="underline-btn"
                    @click="$bvModal.hide('modalCancle')"
                >
                    ไม่ต้องการ
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
// helper
import Account from "@/helper/AccountHelper.js";
// plugin
import moment from "moment";
// core //
import {
    CampaignListConfigBuilder,
    CampaignListFilterConfigBuilder
} from "@/core/Campaign/model/CampaignConfigModel.js";
//service
import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign.js";
//components
import ChangePlanItem from "@/module/Order/component/ChangePlanItem.vue";
import LocationDropdown from "@/components/Input/LocationDropdown.vue";

export default {
    name: "changeplan",
    components: {
        ChangePlanItem,
        LocationDropdown
    },
    data() {
        return {
            dateTime: "",
            setLocation: "",
            setTime: "",

            //config
            campaignListConfig: {},
            campaginListFilterConfig: {},

            //loadcampaign
            isLoaded: false,
            campaigns: [],
            activeCampaign: null,

            pathGoBack: ""
        };
    },
    mounted() {
        const initData = this.initData();
        const initCampaign = this.initialCampaign();

        Promise.all([initData, initCampaign])
            .then(() => {
                this.getList();
            })
            .catch(err => {
                console.log(err);
            });
    },
    methods: {
        initData() {
            //set header datetime
            this.pathGoBack = "changeplan/" + this.$route.params.date;
            var timeStamp = parseInt(this.$route.params.date + "000");
            var timeDate = moment(timeStamp).format("LL");
            this.setTime = moment(timeStamp).format("h : mm");
            var timeArray = timeDate.split(" ");
            var year = parseInt(timeArray[2]) + 543;
            this.dateTime = timeArray[0] + " " + timeArray[1] + " " + year;

            //set location tab
            this.setLocation = this.$store.state.location.location;
        },
        backHistory() {
            this.$router.push("/order");
        },
        gotoMap: function() {
            this.$router.push("/cafemap/changeplan?" + this.$route.params.date);
        },
        initialCampaign: function() {
            return new Promise(resolve => {
                this.campaignListConfig = {};
                this.campaginListFilterConfig = {};

                var listConfig = new CampaignListConfigBuilder()
                    .setConfigList("campaign_nescafestreetcafe_menu")
                    .setTop(25);

                this.campaignListConfig = listConfig.create();

                var filterConfig = new CampaignListFilterConfigBuilder();
                this.campaginListFilterConfig = filterConfig.create();

                console.log(this.campaginListFilterConfig);

                resolve(this.campaginListFilterConfig);
            });
        },
        getList() {
            return new Promise((resolve, reject) => {
                this.isLoaded = false;
                console.log(this.campaignListConfig, "step1");
                if (!this.campaignListConfig.strConfigList) return;
                var strBzbsToken = Account.getToken();
                BzbsCampaign.apiGetCampaign(
                    strBzbsToken,
                    this.campaignListConfig,
                    this.campaginListFilterConfig
                ).subscribe(
                    campaigns => {
                        this.campaignListConfig.intSkip += this.campaignListConfig.defaultTopAmount;
                        //check is there are more campaign.
                        if (
                            campaigns &&
                            campaigns.length <
                                this.campaignListConfig.defaultTopAmount
                        )
                            this.campaignListConfig.isSeeMoreEnable = false;

                        //reinitialize list if no skip.
                        if (
                            this.campaignListConfig.intSkip ==
                            this.campaignListConfig.defaultTopAmount
                        )
                            this.campaigns = [];

                        for (var campaign of campaigns) {
                            //TODO: Add GA Tracking.
                            this.campaigns.push(campaign);
                        }

                        this.isLoaded = true;
                        // console.log(campaigns)
                        resolve(campaigns);
                    },
                    err => {
                        this.isLoaded = true;
                        reject(err);
                    }
                );
            });
        },
        chooseCampaign(index) {
            this.activeCampaign = index;
            console.log(this.activeCampaign);
        }
    }
};
</script>

<style lang="scss" scoped>
@import "@/module/Order/style/orderStyle.scss";
.main-layout {
    background: url("../../../assets/home/BG@3x.png");
    background-size: 100%;
    min-height: 100vh;
}
::v-deep.wrapper__location {
    margin-top: 0;
}
.coffee:after {
    display: none;
}
.main-changeplan {
    padding: 0 20px;
    .menu-container {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 5px;
        padding: 11px;
        background: #000;
        border-radius: 15px;
    }
}
.footer-main {
    .footer-header {
        height: 42px;
        background-image: linear-gradient(
            to top,
            rgba(0, 0, 0, 0.7),
            rgba(0, 0, 0, 0.3) 40%,
            rgba(0, 0, 0, 0) 0%
        );
    }
    .footer-body {
        background-color: #000;
        padding: 10px 20px;
    }
}
</style>
